<app-button
  #resetColumnsBtn
  (click)="resetColumns()"
  [matTooltip]="'global.resetColumns' | translate"
  [matTooltipPosition]="'left'"
  [disabled]="false"
  class="absolute right-1 top-1"
  aria-label="Reset Columns Button"
  [shape]="ButtonShape.ROUNDED"
  [icon]="'rotate_left'"
  [size]="ButtonSize.SM"
  [color]="ButtonColor.GRAY" />

<ag-grid-angular
  #gridComponent
  (gridReady)="onGridReady($event)"
  (rowDragEnd)="emitEnd($event)"
  (rowDragMove)="emitMove($event)"
  (columnMoved)="emitColumnMoved($event)"
  (modelUpdated)="emitModelUpdated($event)"
  (componentStateChanged)="onStateChanged($event)"
  (sortChanged)="onSortChanged($event)"
  (paginationChanged)="emitPageSizeChanged($event)"
  *ngIf="isGridVisible"
  [columnDefs]="colDefs"
  [gridOptions]="options"
  [ngClass]="tableThemeClass"
  [paginationPageSize]="paginationPageSize"
  [pagination]="showPagination"
  [rowData]="rowData"
  [rowDragManaged]="false"
  [loadingOverlayComponent]="loadingOverlayComponent"
  [overlayNoRowsTemplate]="noRowsTemplate"
  class="h-full w-full" />
